const hasPermission = (permissionsRoute: string[] = [], permissions: string[] = []) => {
  let hasPerm: boolean;
  if (permissionsRoute.includes("*") || permissions.includes("*")) {
    hasPerm = true;
  } else {
    const checkPerms = permissionsRoute.map((item: string) => permissions.includes(item));
    hasPerm = checkPerms.every((item: boolean) => item);
  }
  return hasPerm;
};

export default hasPermission;
